import { useSettingsStore, type PluginOptions } from '@/layouts/sfapp';
import { projectSettings } from '@/settings/index';

const options: PluginOptions = {
  onVuePluginRegister: async () => {
    const { initSettings } = useSettingsStore();
    initSettings(projectSettings);
  },
};

export default options;
